/**
 * Construye una URL completa y válida para imágenes o recursos estáticos,
 * adaptándose automáticamente al origen actual del navegador en tiempo de ejecución.
 * Esto elimina los bloqueos de CORS generados cuando el usuario accede con 'www.'
 * frente a URLs sin 'www.', manteniendo todas las solicitudes en el mismo origen (Same-Origin).
 *
 * @param {String} rutaRelativaOAbsoluta - La ruta de la imagen (ej: '/media/img.png' o 'https://sigaf.tamep.bo/media/img.png')
 * @returns {String} URL absoluta alineada al origen del navegador.
 */
export const construirUrlImagen = (rutaRelativaOAbsoluta) => {
  if (!rutaRelativaOAbsoluta) return '';

  // 1. Detectar el origen actual del navegador (ej: 'https://www.sigaf.tamep.bo' o 'https://sigaf.tamep.bo')
  let origenActual = 'https://sigaf.tamep.bo';
  if (typeof window !== 'undefined' && window.location && window.location.origin) {
    origenActual = window.location.origin;
  } else if (process.env.VUE_APP_API_URL) {
    try {
      origenActual = new URL(process.env.VUE_APP_API_URL).origin;
    } catch (_) {
      origenActual = process.env.VUE_APP_API_URL.replace(/\/+$/, '');
    }
  }

  // 2. Si ya viene como URL absoluta con protocolo
  if (rutaRelativaOAbsoluta.startsWith('http://') || rutaRelativaOAbsoluta.startsWith('https://')) {
    try {
      const urlObj = new URL(rutaRelativaOAbsoluta);
      // Si la URL apunta a servidores de TAMEP o entornos locales, reutilizamos el pathname
      // para que coincida exactamente con el origen actual de navegación (Same-Origin)
      if (
        urlObj.hostname.includes('tamep.bo') ||
        urlObj.hostname.includes('localhost') ||
        urlObj.hostname.includes('127.0.0.1')
      ) {
        return `${origenActual}${urlObj.pathname}`;
      }
      return rutaRelativaOAbsoluta;
    } catch (_) {
      return rutaRelativaOAbsoluta.replace('siaem.tamep.bo', 'sigaf.tamep.bo');
    }
  }

  // 3. Si viene como ruta relativa (ej: '/media/qrs/...')
  const path = rutaRelativaOAbsoluta.startsWith('/') ? rutaRelativaOAbsoluta : `/${rutaRelativaOAbsoluta}`;
  return `${origenActual}${path}`;
};
